module.exports = __webpack_public_path__ + "img/封装.235c7409.svg";